import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminLayout from "@/components/AdminLayout";

import Scanner from "@/pages/Scanner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Vouchers from "@/pages/Vouchers";
import VoucherDetail from "@/pages/VoucherDetail";
import Coupons from "@/pages/Coupons";
import CouponDetail from "@/pages/CouponDetail";
import Branches from "@/pages/Branches";
import CostShops from "@/pages/CostShops";
import Users from "@/pages/Users";
import ApiKeys from "@/pages/ApiKeys";
import Reports from "@/pages/Reports";
import BundleTemplates from "@/pages/BundleTemplates";
import EmailTemplate from "@/pages/EmailTemplate";
function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Scanner />} />
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/admin"
                            element={
                                <ProtectedRoute>
                                    <AdminLayout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="vouchers" element={<Vouchers />} />
                            <Route path="vouchers/:id" element={<VoucherDetail />} />
                            <Route path="coupons" element={<Coupons />} />
                            <Route path="coupons/:id" element={<CouponDetail />} />
                            <Route path="branches" element={<Branches />} />
                            <Route path="cost-shops" element={<CostShops />} />
                            <Route path="bundle-templates" element={<BundleTemplates />} />
                            <Route path="email-template" element={<EmailTemplate />} />
                            <Route path="email-templates" element={<EmailTemplate />} />
                            <Route path="reports" element={<Reports />} />
                            <Route
                                path="users"
                                element={
                                    <ProtectedRoute master>
                                        <Users />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="api-keys"
                                element={
                                    <ProtectedRoute master>
                                        <ApiKeys />
                                    </ProtectedRoute>
                                }
                            />
                        </Route>
                    </Routes>
                    <Toaster richColors position="top-right" />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
